import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@app/services/notification.service';
import { Apollo } from 'apollo-angular';
import { MocargaService } from '@app/services/mocarga.service';

@Component({
  selector: 'app-liberacarga',
  templateUrl: './liberacarga.component.html',
  styleUrls: ['./liberacarga.component.css']
})
export class LiberacargaComponent implements OnInit {

  loading = false;
  public myData: any;
  public numeroCarga: string;
  public _mocargaForm: FormGroup;

  constructor(private _formBuilder: FormBuilder,
  private dialogRef: MatDialogRef<LiberacargaComponent>,
  private _mocargaService: MocargaService,
  private notificationService: NotificationService,
  @Inject(MAT_DIALOG_DATA) public data: any, private apollo: Apollo) { }

  onNoClick(): void {
    this.dialogRef.close();
   }
// licencia: licencia, fechaLiberacion: fechaLiberacion, zarpeNumero: this.zarpeModel.numero
ngOnInit() {
    console.log(this.data);
    this._mocargaForm = this._formBuilder.group({
      numero: [this.data.carga.obtenerCarga.carNumero],
      embarcacion: [this.data.carga.obtenerCarga.embNicRaEmbarca, [Validators.required]],
      fecha: [ this.formatDate(new Date(this.data.carga.obtenerCarga.carFechaCarga)), [Validators.required]],
      fechaLiberacion: [ this.formatDate(new Date(this.data.carga.obtenerCarga.carFechaDescargue)), [Validators.required]],
      kmInicial: [ this.data.carga.obtenerCarga.carPuntoIni, [Validators.required]],
      kmFinal: [ this.data.carga.obtenerCarga.carPuntoFin, [Validators.required]],
    }, {validator: this.dateLessThan('fecha', 'fechaLiberacion')});
}
  onSubmit() {
    this.myData = this._mocargaForm.value;
    console.log(this.myData.fechaLiberacion);
    this._mocargaService
    .mutate({
      cargaNumero: this.myData.numero,
      kmInicio: this.myData.kmInicial,
      kmFinal: this.myData.kmFinal,
      fecha: this.myData.fechaLiberacion
    })
    .subscribe(({ data }: any) => {
      console.log(data);
      this.loading = false;
      this.notificationService.showNotification('Resultado!', data.editarLiberacionCarga, 'success');
      // this.zarpeModel.estadoZarpe = 'FINALIZADO';

      // location.href = '#/zarpes';
    },
      (error) => {
        this.loading = false;
        console.log(error);
       this.notificationService.showNotification('Ha ocurrido un error', 'No cumple con requerimientos', 'warning');
      }
    )

    this.dialogRef.close();

  }

  dateLessThan(from: string, to: string) {
    return (group: FormGroup): {[key: string]: any} => {
     const f = group.controls[from];
     const t = group.controls[to];
     if (f.value > t.value) {
       return {
         dates: 'Fecha Inicial debe ser menor o igual a la final'
       };
     }
     return {};
    }
  }
  formatDate(date) {
    // tslint:disable-next-line: prefer-const
    let d: Date = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        // tslint:disable-next-line: prefer-const
        year = d.getFullYear();

    if (month.length < 2){
        month = '0' + month;}
    if (day.length < 2){
        day = '0' + day;}

    return [year, month, day].join('-');
}
 
}
